import Types from 'pages/workouts/util/Types';

const WorkoutOptions = {
    AutoAddRestStepAfterSteps: false,
    CanDeleteStepsInsideRepeater: true,
    CanSortStepsInsideRepeater: true,
    MaxSteps: 100,
    DefaultRepeatIteration: 2,
    subSportType: Types.HiitSubSportTypes.GENERIC,
    LabelAddRepeat: 'workout.add.round'
};

const isExerciseRequiredBasedOnStepType = (stepType) => {
    return true;
};

/**
 * Backbone Reference: getStepSelectOptions().StepType in backbone/pages/workouts/workoutConfig/HiitWorkoutV2.js
 */
const getStepTypeSelectionItems = () => {
    return [
        {
            value: Types.StepTypes.Warm_Up,
            textKey: 'workout:workout.stepType.warmup'
        },
        {
            value: Types.StepTypes.Interval,
            textKey: 'workout:exercise_label'
        },
        {
            value: Types.StepTypes.Cool_Down,
            textKey: 'workout:workout.stepType.cooldown'
        },
        {
            value: Types.StepTypes.Rest,
            textKey: 'workout:workout.stepType.rest'
        },
        {
            value: Types.StepTypes.Recovery,
            textKey: 'workout:workout.stepType.recovery'
        },
        {
            value: Types.StepTypes.Other,
            textKey: 'workout:workout.step.type.other'
        }
    ];
};

/**
 * Backbone Reference: getDurationOptionsBasedOnStepType in backbone/pages/workouts/workoutConfig/HiitWorkoutV2.js
 */
const getDurationTypeSelectionItems = (stepType, isInsideTimeRepeater) => {
    let types;
    if (stepType === Types.StepTypes.Rest) {
        types = [
            {
                value: Types.ConditionTypes.Time,
                textKey: 'units:label_time'
            },
            {
                value: Types.ConditionTypes.Lap_Button,
                textKey: 'workout:workout.step.duration.type.lap.button'
            },
            {
                value: Types.ConditionTypes.Heart_Rate,
                textKey: 'units:label_heart_rate'
            }
        ];
    } else {
        types = [
            {
                value: Types.ConditionTypes.Reps,
                textKey: 'units:label_reps'
            },
            {
                value: Types.ConditionTypes.Time,
                textKey: 'units:label_time'
            },
            {
                value: Types.ConditionTypes.Lap_Button,
                textKey: 'workout:workout.step.duration.type.lap.button'
            },
            {
                value: Types.ConditionTypes.Calories,
                textKey: 'units:label_calories'
            },
            {
                value: Types.ConditionTypes.Heart_Rate,
                textKey: 'units:label_heart_rate'
            }
        ];
    }

    if (isInsideTimeRepeater) {
        // we don't allow Time as the option of Duration when it's inside time-based repeater
        types = types.filter((type) => type.value !== Types.ConditionTypes.Time);
    }

    return types;
};

const getTargetTypeSelectionItems = () => [
    {
        value: Types.TargetTypes.No_Target,
        textKey: 'workout:workout_step_target_no_target_label'
    },
    {
        value: Types.ChildTargetTypes.Select_Heart_Rate_Zone,
        textKey: 'workout:select_heart_rate_zone_label'
    }
];

const RepeatOptions = {
    [Types.RepeatTypes.Iterations]: {
        type: Types.ConditionTypes.Iterations,
        value: Types.RepeatTypes.Iterations,
        text: 'workout.number.of.times',
        unit: 'workout.repeat.title.rounds',
        min: 2,
        max: 40,
        defaultValue: 2
    },
    [Types.RepeatTypes.Time]: {
        type: Types.ConditionTypes.Time,
        value: Types.RepeatTypes.Time,
        text: 'workout.repeat.until',
        unit: 'hh_mm_ss_label',
        min: 1,
        max: 24 * 60 * 60 - 1, // 23 hr 59 min 59 sec
        defaultValue: 10 * 60
    }
};

/**
 * get weight option items for hiit workout
 * Backbone Reference:
 * 1. getBenchmarkScalingWeightOptions in backbone/pages/workouts/workoutConfig/HiitWorkoutV2.js
 * 2. getSelectOptionValues in backbone/pages/workouts/dropdowns/BenchmarkScalingWeightDropdown.js
 * @param {Boolean} exerciseHasBodyWeight
 * @returns {Array} weight option list
 */
const getBenchmarkScalingWeightOptions = (exerciseHasBodyWeight = false) => [
    {
        value: Types.BenchmarkScalingTypes.Not_Set,
        textKey: exerciseHasBodyWeight ? 'workout:not_set_bodyweight' : 'workout:not_set'
    },
    {
        value: Types.BenchmarkScalingTypes.Manual,
        textKey: 'workout:manual_weight'
    }
];

export default {
    WorkoutOptions,
    getStepTypeSelectionItems,
    getDurationTypeSelectionItems,
    isExerciseRequiredBasedOnStepType,
    getTargetTypeSelectionItems,
    RepeatOptions,
    getBenchmarkScalingWeightOptions
};
